import Breadcrumbs from '../components/shared/Breadcrumbs';

const HaftungsausschlussPage = () => {
  return (
    <div className="py-12" data-testid="haftungsausschluss-page">
      <div className="container-wide">
        <Breadcrumbs items={[{ label: 'Haftungsausschluss', href: '/haftungsausschluss' }]} />

        <div className="max-w-3xl">
          <h1 className="mb-8">Haftungsausschluss (Disclaimer)</h1>

          <div className="prose-reviewlex">
            <section className="mb-8">
              <h2>Allgemeiner Haftungsausschluss</h2>
              <p>
                Die auf ReviewLex.de bereitgestellten Inhalte dienen ausschließlich zu allgemeinen 
                Informationszwecken. Obwohl wir uns bemühen, stets aktuelle, korrekte und vollständige 
                Informationen bereitzustellen, können wir keine Garantie für die Richtigkeit, 
                Vollständigkeit oder Aktualität der Inhalte übernehmen.
              </p>
            </section>

            <section className="mb-8">
              <h2>Keine Rechts-, Steuer- oder Finanzberatung</h2>
              <p>
                <strong>Die Inhalte auf ReviewLex.de stellen keine Rechts-, Steuer- oder 
                Finanzberatung dar.</strong> Wir sind keine Anwälte, Steuerberater oder 
                Finanzberater. Die bereitgestellten Informationen ersetzen nicht die individuelle 
                Beratung durch einen qualifizierten Fachmann.
              </p>
              <p>
                Jede Entscheidung, die Sie auf Basis der auf dieser Website gefundenen Informationen 
                treffen, erfolgt auf Ihr eigenes Risiko. Wir empfehlen dringend, vor der Gründung 
                eines Unternehmens im Ausland oder bei steuerlichen Fragen einen spezialisierten 
                Anwalt oder Steuerberater zu konsultieren.
              </p>
            </section>

            <section className="mb-8">
              <h2>Genauigkeit der Informationen</h2>
              <p>
                Wir bemühen uns, die Informationen auf dieser Website regelmäßig zu überprüfen und 
                zu aktualisieren. Gesetze, Vorschriften, Gebühren und Anforderungen können sich 
                jedoch jederzeit ändern. Wir können nicht garantieren, dass alle Informationen zum 
                Zeitpunkt Ihres Besuchs noch aktuell sind.
              </p>
              <p>
                Insbesondere bei folgenden Angaben kann es zu Änderungen kommen:
              </p>
              <ul>
                <li>Staatliche Gebühren und Steuersätze</li>
                <li>Anforderungen für die Unternehmensgründung</li>
                <li>Preise von Drittanbietern (z.B. Registered Agent Services)</li>
                <li>Gesetzliche Vorschriften in verschiedenen Jurisdiktionen</li>
              </ul>
              <p>
                Wir empfehlen, wichtige Informationen immer direkt bei den zuständigen Behörden 
                oder Dienstleistern zu verifizieren.
              </p>
            </section>

            <section className="mb-8">
              <h2>Empfehlungen und Bewertungen</h2>
              <p>
                Die auf dieser Website veröffentlichten Bewertungen und Empfehlungen basieren auf 
                unseren eigenen Tests und Erfahrungen. Wir empfehlen Services, von deren Qualität 
                wir überzeugt sind, aber Ihre Erfahrungen können davon abweichen.
              </p>
              <p>
                Die Eignung eines bestimmten Services für Ihre spezifische Situation hängt von 
                vielen individuellen Faktoren ab, die wir nicht berücksichtigen können. Prüfen 
                Sie daher immer selbst, ob ein empfohlener Service für Ihre Bedürfnisse geeignet ist.
              </p>
            </section>

            <section className="mb-8">
              <h2>Externe Links</h2>
              <p>
                Unsere Website enthält Links zu externen Websites Dritter. Wir haben keinen 
                Einfluss auf die Inhalte dieser verlinkten Seiten und übernehmen keine Verantwortung 
                für deren Inhalte oder Datenschutzpraktiken.
              </p>
              <p>
                Die Verlinkung auf externe Websites stellt keine Empfehlung oder Billigung der 
                dort angebotenen Produkte, Dienstleistungen oder Informationen dar, sofern dies 
                nicht ausdrücklich angegeben ist.
              </p>
            </section>

            <section className="mb-8">
              <h2>Affiliate-Links</h2>
              <p>
                Diese Website enthält Affiliate-Links. Wenn Sie über einen solchen Link einen 
                Service erwerben, erhalten wir möglicherweise eine Provision. Dies hat keinen 
                Einfluss auf den Preis, den Sie zahlen, kann aber unsere Empfehlungen beeinflussen, 
                auch wenn wir uns um Objektivität bemühen.
              </p>
              <p>
                Weitere Informationen finden Sie in unserer{' '}
                <a href="/affiliate-offenlegung" className="text-teal-600 hover:text-teal-700">
                  Affiliate-Offenlegung
                </a>.
              </p>
            </section>

            <section className="mb-8">
              <h2>Haftungsbeschränkung</h2>
              <p>
                Soweit gesetzlich zulässig, schließen wir jegliche Haftung für direkte, indirekte, 
                zufällige, besondere, Folge- oder Strafschäden aus, die sich aus der Nutzung oder 
                Unmöglichkeit der Nutzung dieser Website oder der darauf enthaltenen Informationen 
                ergeben.
              </p>
              <p>
                Dies gilt auch für:
              </p>
              <ul>
                <li>Finanzielle Verluste durch Geschäftsentscheidungen, die auf unseren Informationen basieren</li>
                <li>Schäden durch fehlerhafte oder unvollständige Informationen</li>
                <li>Probleme mit von uns empfohlenen Drittanbietern</li>
                <li>Rechtliche oder steuerliche Konsequenzen aus Unternehmensgründungen</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2>Änderungen</h2>
              <p>
                Wir behalten uns das Recht vor, diesen Haftungsausschluss jederzeit zu ändern. 
                Änderungen werden auf dieser Seite veröffentlicht. Durch die fortgesetzte 
                Nutzung der Website nach solchen Änderungen stimmen Sie dem geänderten 
                Haftungsausschluss zu.
              </p>
            </section>

            <section className="mb-8">
              <h2>Geltendes Recht</h2>
              <p>
                Dieser Haftungsausschluss unterliegt dem Recht der Bundesrepublik Deutschland. 
                Gerichtsstand für alle Streitigkeiten ist, soweit gesetzlich zulässig, der 
                Sitz des Betreibers.
              </p>
            </section>

            <p className="text-sm text-slate-500 mt-12">
              Stand: April 2026
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HaftungsausschlussPage;
